// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2tstM","title":"ClientCherryInfo_title__AkqcZ","itemText":"ClientCherryInfo_itemText__1SjEE"};